<template>
    <v-container fluid fill-height pa-0>
        <iframe class="storymap"
                src="http://studymaps.ethz.ch/sustainability-atlas/maps/group1/"></iframe>
    </v-container>
</template>

<script>
    export default {
        name: 'Story-1'
    }
</script>

<style>
    .storymap {
        width: 100%;
        height: 100%;
        border: 0;
    }

    html {
        overflow-y: hidden;
    }
</style>